import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import CustomerManagement from './pages/CustomerManagement';
import RateMaster from './pages/RateMaster';
import BookingEntry from './pages/BookingEntry';
import MultipleBooking from './pages/MultipleBooking';
import MultipleBookingView from './pages/MultipleBookingView';
import BookingModify from './pages/BookingModify';
import ViewBookings from './pages/ViewBookings';
import BulkModify from './pages/BulkModify';
import InvoiceGenerator from './pages/InvoiceGenerator';
import NonGstInvoiceGenerator from './pages/NonGstInvoiceGenerator';
import ViewInvoices from './pages/ViewInvoices';
import ViewNonGstInvoices from './pages/ViewNonGstInvoices';
import ComingSoon from './pages/ComingSoon';
import DownloadInvoice from './pages/DownloadInvoice';
import Login from './pages/Login';
import Home from './pages/Home';
import ProtectedRoute from './utils/ProtectedRoute';
import { AuthProvider } from './utils/AuthContext';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<Layout />}>
                {/* Removed duplicate '/' route for Dashboard. Use '/dashboard' only. */}
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/rates" element={<RateMaster />} />
                <Route path="/customers" element={<CustomerManagement />} />
                <Route path="/booking" element={<BookingEntry />} />
                <Route path="/booking/multiple" element={<MultipleBooking />} />
                <Route path="/booking/multiple/view" element={<MultipleBookingView />} />
                <Route path="/booking/modify" element={<BookingModify />} />
                <Route path="/booking/view" element={<ViewBookings />} />
                <Route path="/booking/bulk-modify" element={<BulkModify />} />
                <Route path="/invoice-generator" element={<InvoiceGenerator />} />
                <Route path="/invoice-generator-non-gst" element={<NonGstInvoiceGenerator />} />
                <Route path="/invoices" element={<ViewInvoices />} />
                <Route path="/invoices-non-gst" element={<ViewNonGstInvoices />} />
                <Route path="/invoices/download" element={<DownloadInvoice />} />
              </Route>
            </Route>
          </Routes>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;